import './app.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

// Painel super-admin (F3-05 T08): SPA Vue standalone, sem PWA. Auth por cookie
// Sanctum; rotas/guard em ./router; sessão em ./stores/superAdmin.
const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
